export default "__VITE_ASSET__cb660ca5__"